import React from 'react';
import { IconProps } from '../types';

export const UIDesignIcon = ({ color }: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
        <path
            d="M18.6666 25.3333H13.3333V30.6666H18.6666V25.3333Z"
            stroke={color}
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="square"
        />
        <path
            d="M20 1.33331H12V6.66665H20V1.33331Z"
            stroke={color}
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="square"
        />
        <path
            d="M30.6666 25.3333H25.3333V30.6666H30.6666V25.3333Z"
            stroke={color}
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="square"
        />
        <path
            d="M6.66659 25.3333H1.33325V30.6666H6.66659V25.3333Z"
            stroke={color}
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="square"
        />
        <path d="M16 8V25.3333" stroke={color} strokeWidth="2" strokeMiterlimit="10" strokeLinecap="square" />
        <path d="M4 24V14.6667H28V24" stroke={color} strokeWidth="2" strokeMiterlimit="10" strokeLinecap="square" />
    </svg>
);
